import { useEffect, useState } from "react";
import VoiceCallAudio from "./VoiceCallAudio";

const rtcConfig = {
  iceServers: [
    {
      urls: ["stun:stun.l.google.com:19302"],
    },
    {
      urls: ["turn:160.98.47.137:8000"],
      username: "rosas",
      credential: "9xaYw3wns6wCfYJ4",
    },
  ],
};

function VoiceCallRTC({ serverState, infrastructureSend, localStream }) {
  const [peerConnection, setPeerConnection] = useState(null);
  const [remoteStream, setRemoteStream] = useState(null);

  // using a string to emulate a deep object comparison in useEffect depdendencies
  const vuiDescriptionStr = JSON.stringify(serverState.rtcInfo.vuiDescription);
  const vuiLastIceCandidateStr = JSON.stringify(
    serverState.rtcInfo.vuiLastIceCandidate
  );

  useEffect(() => setPeerConnection(new RTCPeerConnection(rtcConfig)), []);

  useEffect(() => {
    if (!peerConnection) return;

    localStream.getTracks().forEach((track) => {
      peerConnection.addTrack(track, localStream);
    });
  }, [peerConnection, localStream]);

  useEffect(() => {
    if (!peerConnection) return;

    peerConnection.onicecandidate = (e) => {
      infrastructureSend("infrastructure", "rtcIceCandidate", {
        vuiId: serverState.vuiId,
        candidate: e.candidate,
      });
    };

    peerConnection.ontrack = (e) => {
      if (e.streams && e.streams[0]) {
        setRemoteStream(e.streams[0]);
      }
    };

    peerConnection.createOffer().then((description) => {
      peerConnection.setLocalDescription(description).then(() => {
        infrastructureSend("infrastructure", "rtcOffer", {
          vuiId: serverState.vuiId,
          description: peerConnection.localDescription,
        });
      });
    });
  }, [peerConnection, infrastructureSend, serverState.vuiId]);

  useEffect(() => {
    if (!peerConnection || vuiDescriptionStr === undefined) return;

    peerConnection.setRemoteDescription(JSON.parse(vuiDescriptionStr));
  }, [peerConnection, vuiDescriptionStr]);

  useEffect(() => {
    if (!peerConnection || vuiLastIceCandidateStr === undefined) return;

    peerConnection.addIceCandidate(JSON.parse(vuiLastIceCandidateStr));
  }, [peerConnection, vuiLastIceCandidateStr]);

  return remoteStream ? <VoiceCallAudio stream={remoteStream} /> : null;
}

export default VoiceCallRTC;
